module.exports = __webpack_public_path__ + "img/system.5b4d2a42.svg";